export default "__VITE_ASSET__BcDkVexL__"